module.exports = require('./lib/static/prefixAll')



/*****************
 ** WEBPACK FOOTER
 ** /jobvolume/donatenodeweb-ci-9488/workspace/Release/~/inline-style-prefixer/static.js
 ** module id = 311
 ** module chunks = 6
 **/